module.exports = "<svg viewBox=\"0 0 163.802 163.802\"><path fill=\"#010202\" d=\"M157.005 65.491L98.311 6.797c-9.063-9.063-23.758-9.062-32.82 0L6.797 65.491c-9.063 9.063-9.063 23.757.001 32.82l58.693 58.693c9.064 9.063 23.757 9.063 32.819 0l58.695-58.693c9.061-9.063 9.063-23.757 0-32.82zm-75.104 66.867c-8.134 0-14.728-6.594-14.728-14.727 0-8.134 6.594-14.729 14.728-14.729s14.728 6.595 14.728 14.729c0 8.133-6.594 14.727-14.728 14.727zm10.023-41.122c0 3.456-20.044 3.456-20.044 0l-7.421-50.533c0-3.455 2.8-6.257 6.255-6.257h22.374a6.257 6.257 0 0 1 6.256 6.257l-7.42 50.533z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/privacy.svg
// module id = 312
// module chunks = 1